/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CalendarioScolastico } from './calendarioScolastico';
import { ConfigurazioneComuneView } from './configurazioneComuneView';
import { PastiDipendenti } from './pastiDipendenti';

export interface Scuola { 
    id?: string;
    annoDiRiferimento?: string;
    nome?: string;
    indirizzo?: string;
    plessoPadiglione?: string;
    numeroMinimoPastiDaFatturare?: number;
    calendarioScolastico?: CalendarioScolastico;
    pastiDipendenti?: PastiDipendenti;
    giorniChiusura?: Array<string>;
    configurazioneComune?: ConfigurazioneComuneView;
    created_at?: Date;
    updated_at?: Date;
}